<template>
  <div>
    <el-tabs type="card" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="踢腿" name="2">
        <service-kicking ref="SW_KIKING"></service-kicking>
      </el-tab-pane>
      <el-tab-pane label="闭气/换气" name="3">
        <service-breath ref="SW_BREATE" ></service-breath>
      </el-tab-pane>
      <el-tab-pane label="手部动作" name="4">
        <service-hand-movement  ref="SW_HANDMOVE"></service-hand-movement>
      </el-tab-pane>
      <el-tab-pane label="自救课" name="5">
        <service-help-self ref="SW_HELPSELF"></service-help-self>
      </el-tab-pane>
      <el-tab-pane label="速度" name="6">
        <service-sw-speed ref="SW_SPEED"></service-sw-speed>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<style scoped>
  /deep/ .el-tabs__header {
    width: 100%;
    background: #FFFFFF;
    border-radius: 8px;
    height: 56px;
    border: 1px solid #FFFFFF;
  }
  /deep/ .el-tabs__nav-wrap{
    margin-left: 15px;
    margin-top: 10px;
  }
  /deep/ .el-tabs--card>.el-tabs__header .el-tabs__nav {
    border: none;

  }
  /deep/ .el-tabs__item{
    height: 36px;
    color: #0e6eba;
    background: #cedef5;
    margin-right: 10px;
    border-radius: 4px;
    line-height: 36px;
    /* 卡片阴影 */
    box-shadow: 0px 0px 16px 4px rgba(238, 56, 35, 0.09);
  }
  /deep/ .el-tabs__item.is-active{
    color: #ffffff;
    text-align: center;
    background: linear-gradient(120.93deg, #ec9f11 3.98%, #f9bf5e 100%);
  }
  /deep/ .el-tabs__active-bar{
    display: none;
  }
  /deep/ .el-tabs__nav-wrap::after{
    display: none;
  }
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }
</style>
<script>
  import ServiceKicking from "./ServiceKicking";
  import ServiceBreath from "./ServiceBreath";
  import ServiceHandMovement from "./ServiceHandMovement";
  import ServiceSwSpeed from "./ServiceSwSpeed";
  import ServiceHelpSelf from "./ServiceHelpSelf";

  export default {
    name: 'ServiceInteractiveContent',
    components: {
      ServiceHelpSelf,
      ServiceSwSpeed,
      ServiceHandMovement,
      ServiceBreath,
      ServiceKicking,
    },
    data() {
      return {
        activeName: '2',

      }
    },
    created(){

    },
    mounted() {
      this.handleClick();
    },
    methods: {
      handleClick(){
        let ref = this.activeName;
        if (ref == 1){

        } else if (ref == 2) {
          this.$refs["SW_KIKING"].reloadData();
        }else if (ref == 3) {
          console.log("handleClick",ref)
          this.$refs["SW_BREATE"].reloadData();
        }else if (ref == 4) {

          this.$refs["SW_HANDMOVE"].reloadData();
        }else if (ref == 5) {

          this.$refs["SW_HELPSELF"].reloadData();
        }else if (ref == 6) {

          this.$refs["SW_SPEED"].reloadData();
        }else {
          console.log("handleClick wu",ref)
        }
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/my-store/store-setting/after-service-cf/components/ServiceInteractiveContent.vue